import type { WatchpointType } from '@/api/healthcheck';
import type { ConfigState } from '../monitors/WatchpointConfigForms';

/**
 * Route-state passed to `WatchpointCreate` to open the wizard pre-filled. The form
 * reads this from `useLocation().state` and seeds its initial values — so the same
 * create form is reused (no duplication), the user just tweaks and submits.
 */
export interface WatchpointPrefillState {
  name?: string;
  type?: WatchpointType;
  config?: ConfigState;
  check_interval?: number;
  timeout_seconds?: number;
  /** Wizard step to open on (0 Type · 1 Configure · 2 Review). */
  startStep?: 0 | 1 | 2;
}

/**
 * A ready-to-edit example HTTP monitor for first-run onboarding. Points at a
 * placeholder URL so the user immediately sees what a monitor looks like and only
 * has to swap the URL before creating. Nothing is persisted until they submit.
 */
export const SAMPLE_HTTP_MONITOR: WatchpointPrefillState = {
  name: 'Sample monitor',
  type: 'https',
  config: { url: 'https://example.com', method: 'GET', expected_status: 200 },
  check_interval: 60,
  timeout_seconds: 30,
  // Skip the type picker — drop the user straight into Configure to edit the URL.
  startStep: 1,
};
